import { Redirect } from 'expo-router'

export default function OrderListRedirect() {
  return <Redirect href={'/order-list/buy/open'} />
}
